<template>
  <div>
    <div class="row" style="margin-bottom: 12px;">
      <div class="col-md-6">
        <h6>Customer</h6>
        <div class="address">
          Bill To: {{ data.customerName}}
        </div>
        <div class="po-number" v-if="data.poNumber">
          P.O. Number: {{ data.poNumber }}
        </div>
        <div class="po-number" v-if="data.classRef">
          Class: {{ data.classRef }}
        </div>
        <div v-if="data.errors && data.errors.length > 0" class="input-group has-danger" style="margin-top: 12px;">
          <h6 class="error">Errors</h6>
          <ul>
            <li v-for="error in data.errors">{{error}}</li>
          </ul>
        </div>
      </div>
      <div class="col-md-6">
        <h6>QuickBooks</h6>
        <div>
          <span v-if="data.refNumber">Invoice Number: {{ data.refNumber }}</span>
          <span v-else class="error">Invoice Number: INVOICE NUMBER MISSING</span>
        </div>
        <div>
          Date: {{ data.txnDate | formatDateTime }}
        </div>
        <div>
          Created By: {{ getUserDisplayName(data.createdBy) }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <el-table class="table-striped wrap-whole-words tasks-table"
                  :data="data.lineItems"
                  border
                  style="width: 100%">
          <el-table-column
            :min-width="300"
            label="Description">
            <template v-slot="props">
              <p v-html="nl2br(props.row.description)" />
            </template>
          </el-table-column>
          <el-table-column
            :min-width="100"
            label="Item Code"
            prop="itemRef">
          </el-table-column>
          <el-table-column
            :min-width="100"
            label="Class"
            prop="classRef">
          </el-table-column>
          <el-table-column
            :min-width="100"
            label="Task">
            <template v-slot="props">
              <a href="#" @click.prevent="viewTask(props.row.invoiceSubmittalTaskId)">View Task</a>
            </template>
          </el-table-column>
          <el-table-column
            :min-width="100"
            label="Job">
            <template v-slot="props">
              <a href="#" v-if="props.row.jobId" @click.prevent="viewJob(props.row.jobId)">View Job</a>
            </template>
          </el-table-column>
          <el-table-column
            :min-width="100"
            label="Project">
            <template v-slot="props">
              <a href="#" v-if="props.row.projectId" @click.prevent="viewProject(props.row.projectId)">View Project</a>
            </template>
          </el-table-column>
          <el-table-column
            :min-width="150"
            align="right"
            label="Amount">
            <template v-slot="props">
              {{ (props.row.amount * props.row.quantity) | formatPrice }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="row" style="margin-top: 12px;">
      <div class="col-md-12">
        <div class="pull-right">
          <strong>Subtotal: </strong> {{subtotal | formatPrice}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {nl2br} from 'src/utilities/utils'

  export default {
    props: ['data'],
    computed: {
      subtotal() {
        let total = 0
        this.data.lineItems.forEach((lineItem) => {
          total += lineItem.quantity * lineItem.amount
        })
        return total
      }
    },
    methods: {
      nl2br(value) {
        return nl2br(value)
      },
      viewProject(projectId) {
        this.$eventHub.$emit('show-modal-2', 'View Project', {id: projectId}, '1000px')
      },
      viewJob(jobId) {
        this.$eventHub.$emit('show-modal-2', 'View Job', {id: jobId}, '1000px')
      },
      viewTask(taskId) {
        this.$eventHub.$emit('show-modal-2', 'View Task', {id: taskId}, '1000px')
      },
      getUserDisplayName(userId) {
        return this.$store.getters['users/displayName'](userId)
      }
    }
  }
</script>
<style scoped>
.error {
  color: red;
}
</style>
